import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PageView } from '../../../../models/analytics';
import { ProviderEntity } from '../../../../models/provider';
import { messages } from '../../../../payments/legacy/components/PayHandoffDirector/PayHandoff/messages';
import { BoldText } from '../../../../utilities/richTextUtils';
import { AwaitingQrCodeView } from './AwaitingQrCodeView';

export type AwaitingQrCodeScreenWithInstructionsProps = {
  provider: ProviderEntity;
  heading: React.ReactNode;
  qrCode: React.ReactNode;
  allowExit: boolean;
  view?: PageView;
};

export const AwaitingQrCodeScreenWithInstructions = ({
  provider,
  heading,
  qrCode,
  view = PageView.SUBMIT_HANDOFF_CREDENTIALS_SCREEN,
  allowExit,
}: AwaitingQrCodeScreenWithInstructionsProps) => {
  return (
    <AwaitingQrCodeView
      onBack={undefined}
      provider={provider}
      heading={heading}
      qrCode={qrCode}
      view={view}
      allowExit={allowExit}
      instructions={<FormattedMessage {...messages.qrCodeInstructions} values={{ b: BoldText }} />}
    />
  );
};
